import axios from 'axios';
import { auth, db } from '../firebase/firebase';
import { updateName, saveUserPhoto } from './user';
import { serverConfig } from 'util/config';
import { saveMeditation } from './newMeditation';
import {
  SIGNUP_START,
  SIGNUP_COMPLETE,
  SIGNUP_ERROR,
  INSTAGRAM_LOGIN_START,
  INSTAGRAM_LOGIN_COMPLETE,
  INSTAGRAM_LOGIN_ERROR,
  EMAIL_ERROR,
  PASSWORD_ERROR,
  CLEAR_EMAIL_ERROR,
  CLEAR_PASSWORD_ERROR,
  CLEAR_SIGNUP_ERROR,
  USER_IS_LOGGED_IN,
  USER_IS_NOT_LOGGED_IN,
  AUTH_USER,
  AUTH_ERROR,
} from 'constants/types';

export const verifyAuth = () => {
  return dispatch => {
    auth.onAuthStateChanged(user => {
      if (user) {
        dispatch({
          type: AUTH_USER,
          payload: user,
        })
      } else {
        dispatch({ type: AUTH_ERROR });
      }
    })
  }
};

export const createUserWithEmail = (name, email, password, reason, emoji, photoRef, history) => {
  return dispatch => {
    dispatch({ type: SIGNUP_START });
    auth.createUserWithEmailAndPassword(email, password)
      .then(resp => {
        const userId = resp.uid;

        localStorage.setItem('userId', userId);

        dispatch(saveMeditation(userId, reason, emoji, history));
        dispatch(updateName(userId, name));
        dispatch(saveUserPhoto(userId, photoRef));
      })
      .catch(error => {
        if (error.code === 'auth/invalid-email' || error.code === 'auth/email-already-in-use') {
          dispatch({
            type: EMAIL_ERROR,
            payload: error.message,
          })
        } else if (error.code === 'auth/weak-password') {
          dispatch({
            type: PASSWORD_ERROR,
            payload: error.message,
          })
        } else {
          dispatch({
            type: SIGNUP_ERROR,
            payload: error.message,
          })
        }
      })
  }
};

export const loginWithInstagram = (code, history) => {
  return dispatch => {
    dispatch({ type: INSTAGRAM_LOGIN_START });
    axios.get(`${serverConfig}/auth/instagram?code=${code}`)
      .then(response => {
        const userData = response.data;

        auth.signInWithCustomToken(response.data.firebaseToken)
          .then(user => {
            const userId = user.uid;

            localStorage.setItem('firebaseUid', userId);

            db.collection('users').doc(userId).set({
              username: userData.instagramHandle,
              photoURL: userData.profilePicture,
              links: [],
            }, { merge: true })
              .then(() => {
                history.push('/details');
                dispatch({
                  type: INSTAGRAM_LOGIN_COMPLETE,
                  payload: userData.instagramHandle,
                });
              })
              .catch(error => {
                console.error(error);
                dispatch({ type: INSTAGRAM_LOGIN_ERROR });
              });
          })
          .catch(error => {
            console.error(error);
            dispatch({ type: INSTAGRAM_LOGIN_ERROR });
          });
      })
      .catch(error => {
        console.error(error);
        dispatch({ type: INSTAGRAM_LOGIN_ERROR });
      })
  }
};

export const clearEmailError = () => {
  return {
    type: CLEAR_EMAIL_ERROR,
  }
};

export const clearPasswordError = () => {
  return {
    type: CLEAR_PASSWORD_ERROR,
  }
};

export const clearSignupError = () => {
  return {
    type: CLEAR_SIGNUP_ERROR,
  }
};

export const clearErrors = () => {
  return dispatch => {
    dispatch(clearEmailError());
    dispatch(clearPasswordError());
    dispatch(clearSignupError());
  }
};

export const signinWithEmail = (email, password, history) => {
  return dispatch => {
    dispatch(clearEmailError());
    dispatch(clearPasswordError());

    auth.signInWithEmailAndPassword(email, password)
      .then(resp => {
        const userId = resp.uid;
        localStorage.setItem('userId', userId);

        dispatch({
          type: SIGNUP_COMPLETE,
          payload: userId,
        });

        history.push('/profile');
      })
      .catch(error => {
        if (error.code === 'auth/user-not-found') {
          dispatch({
            type: EMAIL_ERROR,
            payload: 'There is no River account with this email',
          })
        } else if (error.code === 'auth/wrong-password') {
          dispatch({
            type: PASSWORD_ERROR,
            payload: 'The password is incorrect',
          })
        } else {
          dispatch({
            type: SIGNUP_ERROR,
            payload: error.message,
          })
        }
      })
  };
};

export const doSignOut = (history) => {
  return dispatch => {
    auth.signOut()
      .then(() => {
        localStorage.removeItem('userId');
        history.push('/login');
      })
      .catch((error) => {
        console.error(error);
      })
  }
};

export const resetPassword = (email) => {
  return dispatch => auth.sendPasswordResetEmail(email);
};

export const updatePassword = (password) => {
  return dispatch => auth.currentUser.updatePassword(password);
};

export const getSessionStatus = (userId) => {
  return dispatch => {
    auth.onAuthStateChanged(user => {
      if (user) {
        if (user.uid === userId) {
          dispatch({ type: USER_IS_LOGGED_IN })
        } else {
          dispatch({ type: USER_IS_NOT_LOGGED_IN })
        }
      } else {
        dispatch({ type: USER_IS_NOT_LOGGED_IN })
      }
    })
  }
};



// WEBPACK FOOTER //
// ./src/actions/session.js